// src/pages/cpaCareerQuiz/components/LeadGenSection.jsx
import { Link } from "react-router-dom";

export default function LeadGenSection() {
  return (
    <div className="leadgen mt-5">
      <h3>掌握關鍵優勢，開啟你的全球職涯！</h3>
      <p className="mt-3">
        恭喜你完成測驗！無論你是想穩紮穩打進入四大會計師事務所，
        還是渴望挑戰全球移動的職涯路徑，Becker 都能提供最專業的支援，
        幫助你用最短時間、完成最終目標！
      </p>

      <div className="mt-4">
        <p className="mb-2"><b>想確認報考門檻？</b> 透過免費報考資格評估，由專人為你核對學分與報考要求。</p>
        <p className="mb-2"><b>想獲取第一手資訊？</b> 追蹤官方 LINE，隨時掌握考試動態與成功案例分享。</p>
      </div>

      <div className="action-buttons mt-4 m-auto">
        <Link to="/consult/form">
          <button type="button" className="action-button">免費報考資格評估</button>
        </Link>

        {/* 之後你把官方 LINE 連結補上 */}
        <a href="#" onClick={(e)=>e.preventDefault()}>
          <button type="button" className="action-button previous_button">追蹤官方 LINE</button>
        </a>
      </div>
    </div>
  );
}
